module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v("Kompanije")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "background": "#2b542c",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.openAddUserModal()
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" Dodaj kompaniju\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "background": "cornflowerblue",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.openAllVouchers()
      }
    }
  }, [_c('i', {
    staticClass: "ti-money"
  }), _vm._v(" Krediti za sve kompanije\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "90%",
      "border-radius": "10px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pretraga",
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showLessGreen),
      expression: "showLessGreen"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showLessGreen) ? _vm._i(_vm.showLessGreen, null) > -1 : (_vm.showLessGreen)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showLessGreen,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showLessGreen = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showLessGreen = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showLessGreen = $$c
        }
      }
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usingVouchers),
      expression: "usingVouchers"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox2"
    },
    domProps: {
      "checked": Array.isArray(_vm.usingVouchers) ? _vm._i(_vm.usingVouchers, null) > -1 : (_vm.usingVouchers)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.usingVouchers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.usingVouchers = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.usingVouchers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.usingVouchers = $$c
        }
      }
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showArchive),
      expression: "showArchive"
    }],
    attrs: {
      "type": "checkbox",
      "id": "cbArchive"
    },
    domProps: {
      "checked": Array.isArray(_vm.showArchive) ? _vm._i(_vm.showArchive, null) > -1 : (_vm.showArchive)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showArchive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showArchive = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showArchive = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showArchive = $$c
        }
      }
    }
  })]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('br'), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed",
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "40px",
      "color": "white"
    }
  }, [_vm._v("R. br")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50px",
      "color": "white"
    }
  }, [_vm._v("Logo")]), _vm._v(" "), (_vm.visibleKey()) ? _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("ID")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Ime kompanije")]), _vm._v(" "), (_vm.isAdmin()) ? _c('th', {
    staticStyle: {
      "width": "100px",
      "color": "white"
    }
  }, [_vm._v("Krediti")]) : _vm._e(), _vm._v(" "), (_vm.isAdmin()) ? _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Dodaj kredite")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Pregled krediti")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Pregled menadžera")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Izmeni")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Obriši")])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredUsers), function(user, index) {
    return _c('tr', {
      staticStyle: {
        "color": "white",
        "background-color": "#4E5066 !important"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.filteredUsers.length - index) + ".")]), _vm._v(" "), (user.profileImageUrl != null) ? _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('img', {
      staticClass: "cropped1",
      attrs: {
        "src": _vm.getCompanyImage(user),
        "width": "50px"
      }
    })]) : _vm._e(), _vm._v(" "), (user.profileImageUrl == null) ? _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('img', {
      staticClass: "cropped1-missing",
      attrs: {
        "src": require("../../assets/img/missingImage.png"),
        "width": "50px",
        "height": "50px"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.visibleKey()) ? _c('td', [_vm._v(_vm._s(user.id))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(user.name) + " ( "), _c('i', {
      staticStyle: {
        "color": "lightcoral"
      }
    }, [_vm._v(_vm._s(_vm.fixArchiveInternalName(user.internalName)))]), _vm._v(" )"), (_vm.visibleKey()) ? _c('button', {
      staticClass: "button-small button-outline",
      staticStyle: {
        "background": "#843534"
      },
      on: {
        "click": function($event) {
          return _vm.showKey(user)
        }
      }
    }, [_c('i', {
      staticClass: "ti-key",
      staticStyle: {
        "color": "white"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', [_c('span', [_vm._v("\n                                " + _vm._s(user.vouchers.green) + "\n                                "), _c('img', {
      staticStyle: {
        "width": "20px",
        "height": "20px"
      },
      attrs: {
        "src": require("../../assets/img/coin.png")
      }
    })])]), _vm._v(" "), (_vm.isAdmin()) ? _c('td', [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "cornflowerblue"
      },
      attrs: {
        "type": "button",
        "placeholder": "Izmeni",
        "name": "Dodaj",
        "value": "+Krediti"
      },
      on: {
        "click": function($event) {
          return _vm.openAddCuponsModal(user)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.isAdmin()) ? _c('td', [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "cornflowerblue"
      },
      attrs: {
        "type": "button",
        "name": "Svi krediti",
        "value": "Svi krediti"
      },
      on: {
        "click": function($event) {
          return _vm.voucherHistory(user)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "cornflowerblue"
      },
      attrs: {
        "type": "button",
        "placeholder": "Menadžeri",
        "name": "Menadžeri",
        "value": "Menadžeri"
      },
      on: {
        "click": function($event) {
          return _vm.openManagers(user.id, user.name)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "cornflowerblue"
      },
      attrs: {
        "type": "button",
        "placeholder": "Izmeni",
        "name": "Izmeni",
        "value": "Izmeni"
      },
      on: {
        "click": function($event) {
          return _vm.editCompany(user)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "#843534"
      },
      attrs: {
        "type": "button",
        "placeholder": "Obriši",
        "name": "Obriši",
        "value": "Obriši"
      },
      on: {
        "click": function($event) {
          return _vm.deleteCompany(user)
        }
      }
    })])])
  }), 0)])])])]), _vm._v(" "), _c('add-company-modal', {
    attrs: {
      "show": _vm.openAddOrder,
      "company": _vm.companyToEdit
    }
  }), _vm._v(" "), _c('add-company-cupons-modal', {
    attrs: {
      "show": _vm.openAddCuponsOrder,
      "company": _vm.companyToAddCupons
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('label', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "for": "checkbox"
    }
  }, [_vm._v("Prikaži kompanije kojima uskoro ističu kuponi "), _c('label', {
    staticStyle: {
      "color": "forestgreen"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('label', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "for": "checkbox2"
    }
  }, [_vm._v("Prikaži samo kompanije koje KORISTE kupone "), _c('label', {
    staticStyle: {
      "color": "forestgreen"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('label', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "for": "cbArchive"
    }
  }, [_vm._v("Prikaži samo arhivirane"), _c('label', {
    staticStyle: {
      "color": "forestgreen"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b711360!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Company/Company.vue
// module id = 459
// module chunks = 1